export * from './commentaire-texte-dialog';